<template>
  <section>
    <v-container id="container" fluid>
      <v-row id="tik" align="center" justify="center" class="pt-5 pt-md-15">
        <v-col cols="12" md="8" class="pt-5 pt-md-15">
          <v-container class="fill-height">
            <v-row justify="left" class="mb-5">
              <v-col cols="11" class="py-0 mt-10 ml-md-15">
                <div class="d-inline-flex">
                  <v-img
                    contain
                    height="50"
                    class="mr-n15 mb-5 pa-0"
                    src="@/assets/logos/horz/tikgestion.svg"
                  ></v-img>
                </div>
                <div>
                  {{ $t("proyectos.tikgestion") }}
                </div>
                <v-btn
                  href="https://tikgestion.com"
                  target="_blank"
                  class="accent my-5"
                  >{{ $t("info.verSitio") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="4"
          align-self="center"
          class="pt-5 pt-md-15 shape verdeFondo"
        >
          <v-img
            contain
            height="300"
            src="@/assets/img/proyectos/tik/screen-tik.png"
          >
          </v-img>
        </v-col>
        <!-- <div class="my-10">
          <v-btn outlined class="ma-2" to="/gestiongr"
            >gestiongr<v-icon right>
              mdi-chevron-left
            </v-icon></v-btn
          >
          <v-btn outlined class="ma-2" to="/pariciones"
            ><v-icon left> mdi-chevron-right </v-icon>pariciones</v-btn
          >
        </div> -->
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Tikgestion",
};
</script>

<style scoped>
#tik {
  min-height: 100vh;
}
.shape {
  border-radius: 30% 70% 67% 33% / 30% 30% 70% 70%;
  background-position: top right;
  width: 200px;
}
</style>
